import { fmtDuration } from '../shared/format';

export function normalizeOutcomeLabel(value: unknown, fallback: string): string {
  const text = String(value || '').trim();
  if (!text) return fallback;
  return text;
}

export function outcomeSymbol(label: string): string {
  const text = (label || '').trim();
  if (!text) return 'TKN';
  const words = text.split(/\s+/).filter(Boolean);
  const numericSuffix = words.find((word) => /^\d+$/.test(word)) || '';
  const alphaWords = words.filter((word) => /[A-Za-z]/.test(word));

  let letters = '';
  if (alphaWords.length === 1) {
    const token = alphaWords[0].replace(/[^A-Za-z0-9]/g, '');
    const caps = token.match(/[A-Z]/g) || [];
    if (caps.length >= 2) {
      letters = caps.slice(0, 3).join('');
    } else if (token.length <= 4) {
      letters = token.toUpperCase();
    } else {
      letters = token.slice(0, 3).toUpperCase();
    }
  } else if (alphaWords.length > 1) {
    letters = alphaWords.map((word) => word[0]).join('').slice(0, 3).toUpperCase();
  }

  const fallback = text.replace(/[^A-Za-z0-9]/g, '').slice(0, 4).toUpperCase() || 'TKN';
  return `${letters || fallback}${numericSuffix}`;
}

export function isZeroAddress(addr?: string | null): boolean {
  return !addr || /^0x0{40}$/i.test(addr);
}

export function displayAddr(addr: string, shortAddr: (value: string) => string): string {
  if (!addr || isZeroAddress(addr)) return 'n/a';
  return `${shortAddr(addr)} (${addr})`;
}

export function reputationLabel(score: number): string {
  if (score >= 80) return 'strong';
  if (score < 40) return 'penalized';
  return 'standard';
}

export function fmtTs(ts: number, nowTs: number): string {
  if (!ts) return 'n/a';
  const rel = ts >= nowTs ? `${fmtDuration(ts - nowTs)} remaining` : `${fmtDuration(nowTs - ts)} ago`;
  return `${new Date(ts * 1000).toLocaleString()} (${rel})`;
}
